import { Card } from "./styles";
import { useState } from "react";
import { useEffect } from "react";

export const ChaCard = ({ name, image, status, origin, species, location }) => {
  const [shortName, setShortName] = useState(name);
  const [borderColor, setBorderColor] = useState("");

  useEffect(() => {
    shortName.length > 15 && setShortName(`${shortName.substring(0, 15)}...`);
    status === "Alive"
      ? setBorderColor("#38b000")
      : status === "Dead"
      ? setBorderColor("red")
      : setBorderColor("#fca311");
  }, [shortName, status]);

  return (
    <Card borderColor={borderColor}>
      <div>
        <h3>{shortName.toUpperCase()}</h3>
      </div>
      <img src={image} alt="" />
      <div className="no-hide">
        <p>{status.toUpperCase()}</p>
      </div>
      <div className="hide">
        <p>
          <strong style={{ fontFamily: "My Writing" }}>Specie:</strong>{" "}
          {species}{" "}
        </p>
        <p>
          <strong style={{ fontFamily: "My Writing" }}>Origin:</strong> {origin}{" "}
        </p>
        <p>
          <strong style={{ fontFamily: "My Writing" }}>Location:</strong>{" "}
          {location}{" "}
        </p>
      </div>
    </Card>
  );
};
